export default __webpack_public_path__ + "static/media/policy-tester.64f210e6.svg";